import React from 'react'
import StyledDiv from './styles'
import { IServiceInfo } from '../../models'
import { images } from '../../images'
import { TagComponent } from './TagComponent'

interface IProps {
  serviceInfo: IServiceInfo,
  onServiceSelected: (serviceInfo: IServiceInfo) => void
}

export const ServiceCheckbox: React.FC<IProps> = ({
  serviceInfo,
  onServiceSelected
}) => {

  const handleCheckboxClick = () => {
    onServiceSelected(serviceInfo)
  }

  return (
    <StyledDiv onClick={ () => onServiceSelected(serviceInfo) }>
      <div className={`checkbox-container ${serviceInfo.selected ? 'selected' : ''}`} onClick={ handleCheckboxClick }>
        <img src={ serviceInfo.selected ? images['checkboxChecked'] : images['checkboxUnchecked']} alt={`service.tag`} />
      </div>
      { <TagComponent tag={ serviceInfo.tag } color={ serviceInfo.color } clickable={true} /> }
      { serviceInfo.name }
    </StyledDiv>
  )
}